import { useEchoAppConfig } from "../composables/useEchoAppConfig.js";
import { createError } from "#app";
export default async function handleAuthToken(app, ctx, logger) {
  const config = app.$config.public.echo;
  if (config.authentication?.mode !== "token") {
    return;
  }
  const { tokenStorage } = useEchoAppConfig();
  if (!tokenStorage) {
    throw createError("Token storage is not defined");
  }
  const token = await tokenStorage.get(app);
  if (!token) {
    logger.debug("Authorization token is missing, unable to set header");
    return;
  }
  ctx.options.headers.set("Authorization", `Bearer ${token}`);
}
